import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export class DateRangeDialogInput {
    title: string;
    zeit_von: Date;
    zeit_bis: Date;
}

export class DateRangeDialogOutput {
    range: DateRangeDialogInput;
    confirm: boolean;
}

@Component({
    selector: 'kiene-date-range-dialog',
    templateUrl: './date-range-dialog.component.html',
    styleUrls: ['./date-range-dialog.component.scss'],
})
export class DateRangeDialogComponent implements OnInit {
    vonCtrl = new FormControl();
    bisCtrl = new FormControl();

    constructor(
        public dialogRef: MatDialogRef<DateRangeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DateRangeDialogInput,
    ) {
        if (data?.zeit_bis) {
            this.bisCtrl.setValue(data.zeit_bis);
        }
        if (data?.zeit_von) {
            this.vonCtrl.setValue(data.zeit_von);
        }
    }

    ngOnInit(): void {}

    disabled(): boolean {
        return !this.vonCtrl.value && !this.bisCtrl.value;
    }

    onSubmit(): void {
        const output = new DateRangeDialogOutput();
        output.range = new DateRangeDialogInput();
        output.range.zeit_von = this.vonCtrl.value;
        output.range.zeit_bis = this.bisCtrl.value;
        output.confirm = true;

        this.dialogRef.close(output);
    }

    onCancel(): void {
        const output = new DateRangeDialogOutput();
        output.confirm = false;
        this.dialogRef.close(output);
    }
}
